<template>
  <PageView class="" :page-reference="PAGE_REFERENCES.FORECASTING" :current-object-type="default_object_type_obj">
    <template #header>
      <TripleMenu
        :set-edit-mode="setEditMode"
        :edit-mode-active="edit_mode_active"
        :quick-actions="top_right_menu_quick_actions"
        :components-actions="top_right_menu_components_actions"
        :current-template="current_template"
        :page-reference="PAGE_REFERENCES.FORECASTING" />
    </template>
    <template #body>
      <LayoutContainer
        v-model:current-template="current_template"
        :set-edit-mode="setEditMode"
        :edit-mode-active="edit_mode_active"
        class="mt-3"
        :page-reference="PAGE_REFERENCES.FORECASTING" />
      <EmptyForecastPage v-if="!current_template" class="mt-[20vh]" />
    </template>
  </PageView>
</template>

<script>
import EmptyForecastPage from "./EmptyForecastPage.vue"
import TripleMenu from "@/components/shared/TripleMenu.vue"
// import ObjectsView from "@/components/shared/object-view/ObjectsView"
import PageView from "@/components/shared/pages/PageView.vue"
import { PAGE_REFERENCES, VIEW_TYPES } from "@/store/constants/references"
import LayoutContainer from "@/components/shared/pages/LayoutContainer.vue"
import { ClipboardList, Mail, Folder, TrendingUp, MessagesSquare, List, ChartNoAxesColumnDecreasing } from "lucide-vue-next"
import ModuleIcon from "@/components/shared/icons/ModuleIcon.vue"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: {
    PageView,
    LayoutContainer,
    TripleMenu,
    EmptyForecastPage
  },
  beforeRouteLeave() {
    // called when the route that renders this component is about to be navigated away from.
    if (this?.edit_mode_active) {
      const answer = window.confirm(this.$t("You have unsaved changes, layout will be reverted if you don't save"))
      if (!answer) {
        return false
      } else {
        this.edit_mode_active = false
      }
    }
  },
  data() {
    return {
      PAGE_REFERENCES,
      current_template: null,
      default_object_type_obj: { type: "default" },
      edit_mode_active: false
    }
  },

  computed: {
    top_right_menu_quick_actions() {
      return [
        {
          name: this.$t("Create a Group"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.CREATE_NEW_GROUP, this.$utils.isUUID(this.$route.params.page) ? null : this.$route.params.page)
          },
          disabled: false,
          icon: Folder
        },
        {
          name: this.$t("Create a Plan"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.CREATE_PLAN)
          },
          disabled: false,
          icon: List
        },
        {
          name: this.$t("Create a Goal"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.CREATE_GOAL)
          },
          disabled: false,
          icon: TrendingUp
        },
        {
          name: this.$t("Create a Task"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.CREATE_TASK)
          },
          disabled: false,
          icon: ClipboardList
        },
        {
          name: this.$t("Create an Interaction"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.CREATE_INTERACTION)
          },
          disabled: false,
          icon: MessagesSquare
        },
        {
          name: this.$t("Send Email"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.SEND_EMAIL)
          },
          disabled: false,
          icon: Mail
        },

        {
          name: this.$t("Create a Custom Metric"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.CREATE_CUSTOM_METRIC, { view_type: "table" })
          },
          disabled: false,
          icon: ChartNoAxesColumnDecreasing
        }
      ]
    },
    top_right_menu_components_actions() {
      return [
        {
          name: this.$t("Edit Layout"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.EDIT_LAYOUT, {
              page_reference: PAGE_REFERENCES.FORECASTING,
              view_type: VIEW_TYPES.ROLLUPS,
              page_name: this.$route.params.page
            })
          },
          disabled: false,
          keyBoardShortcut: "I",
          icon: ModuleIcon
        },
        {
          name: this.$t("Add/Remove Components"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.ADD_NEW_COMPONENT, {
              page_reference: PAGE_REFERENCES.FORECASTING,
              current_template: this.current_template
            })
          },
          disabled: false,
          keyBoardShortcut: "U",
          icon: ModuleIcon
        },
        {
          name: this.current_template?.is_static ? this.$t("Reset Page") : this.$t("Delete Page"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.DELETE_PAGE, this.current_template)
          },
          icon: ModuleIcon
        }
      ]
    }
  },
  methods: {
    setEditMode(value) {
      this.edit_mode_active = value
    }
  }
}
</script>
